import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__inner">

        {/* Left: branding + contact */}
        <div className="footer__brand">
          <p className="footer__tagline">Inspiring Minds, Building Futures</p>
          <ul className="footer__contact">
            <li>
              <span className="icon">📋</span>
              Affiliation No. 153047 Rairangpur PO, Mayurbhanj, Odisha, India – 757043
            </li>
            <li>
              <span className="icon">✉️</span>
              <span className="placeholder">lfsrkrrpmbj@gmail.com</span>
            </li>
            <li>
              <span className="icon">📞</span>
             7655022486
            </li>
            <li>
              <span className="icon">📍</span>
              Location
            </li>
          </ul>
          
          
          
          <div className="footer__socials">
            <a href="#" aria-label="Facebook" className="social-icon">f</a>
            <a href="#" aria-label="YouTube" className="social-icon">▶</a>
            <a href="#" aria-label="LinkedIn" className="social-icon">in</a>
            <a href="#" aria-label="X" className="social-icon">✕</a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer__col">
          <h4>QUICK LINKS</h4>
          <ul>
            <li><a href="#">About Us</a></li>
            <li><a href="#">Achievements </a></li>
            <li><a href="#">Admission</a></li>
            <li><a href="#">Gallery</a></li>
            <li><a href="#">News &amp; Events</a></li>
            <li><a href="#">Parent Portal</a></li>
            <li><a href="#">Jobs</a></li>
            <li><a href="#" className="muted">Contact Us</a></li>
          </ul>
        </div>

        {/* Student Portal */}
        <div className="footer__col">
          <h4>STUDENT PORTAL</h4>
          <ul>
            <li><a href="#">Frequently Asked Questions</a></li>
          </ul>
        </div>

        

      </div>
    </footer>
  );
};

export default Footer;